import { ChangeDetectionStrategy, Component, EventEmitter, Input, OnInit, Output, ViewEncapsulation } from '@angular/core'
import { FormControl, Validators } from '@angular/forms'
import { tap } from 'rxjs/operators'
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy'


@UntilDestroy()
@Component({
  selector: 'dmmp-go-to-paginator',
  templateUrl: './go-to-paginator.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None
})
export class GoToPaginatorComponent implements OnInit {
  @Input() totalPages: string
  @Input() currentIndex = 1
  control: FormControl
  @Output() selectedPage: EventEmitter<number> = new EventEmitter<number>()
  constructor() {
    this.createForm()
  }


  ngOnInit(): void {
    this.listenInputChanges()
  }


  createForm(): void {
      this.control  = new FormControl(this.currentIndex, [
        Validators.min(1)
      ])


  }

  listenInputChanges() {
    this.control.valueChanges
      .pipe(
        tap(it => this.selectedPage.emit(it - 1)),
        untilDestroyed(this)
      ).subscribe()
  }

  sendIndex(event: KeyboardEvent ): void {
    if (this.control.value > this.totalPages) {
        this.control.setValue(this.totalPages)
    }
    if (this.control.value <= 0 ) {
      this.control.setValue(1)
    }
  }

  nextBtn() {
    if (this.control.value <= this.totalPages) {
      const next = Number(this.control.value) + 1
      this.control.setValue(next)
    }
  }

  backBtn() {
    if (this.control.value !== 1) {
      const back = Number(this.control.value) - 1
      this.control.setValue(back)
    }

  }
}
